import React, { Component } from 'react';
import PortResponse from 'components/PortResponse';
import SubNav from 'components/SubNav';
import { prettyKey } from 'helpers/formatters';

class UpdatePort extends Component {
  componentDidMount() {
    this.fetchPortInfo();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.subId !== this.props.subId) {
      this.fetchPortInfo();
    }
    if (oldProps.port !== this.props.port) {
      this.initializeForm();
    }
  }

  fetchPortInfo() {
    const { portInfo, subId } = this.props;
    portInfo(subId);
  }

  initializeForm() {
    const { port, initialize } = this.props;
    initialize('port', port, true);
  }

  render() {
    const {
      subId,
      sub,
      updatePort,
      portResponse,
      port,
      heading,
      PortForm,
      ...props
    } = this.props;
    if (!sub) {
      return <div>Loading</div>;
    }

    return (
      <div>
        <h1>{heading}</h1>
        <SubNav />
        <br />
        {port && (
          <div className="row">
            <div className="col-sm-5">
              <table className="table">
                <tbody>
                  {['mdn_type'].map((attr) => (
                    <tr key={attr}>
                      <td>
                        <b>{prettyKey(attr)}:</b>
                      </td>
                      <td>{port[attr] || 'none'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <PortForm onSubmit={(values) => updatePort(subId, values)} {...props} />
        <br />
        {portResponse && <PortResponse data={portResponse} />}
      </div>
    );
  }
}

export default UpdatePort;
